import {consentChanged, getConsentForGV} from "@otto-ec/eprivacy-cmp";
import {consentEnabled} from "../index";

class SqrlConsentBanner {
    isEnabled: boolean = false;
    /**
 *
 */
    initComplete: Promise<void> = this.update();

    async update() {
        const [ottot, otton] = await Promise.all([
            getConsentForGV("OTTOT"), getConsentForGV("OTTON")
        ]);

        this.isEnabled ||= ottot || otton || false;
        consentEnabled.set(this.isEnabled)
    }

    listenOnConsentChange() {
        consentChanged.on(() => this.update());
    }
}

export const sqrlConsentBanner = new SqrlConsentBanner();
